import { Component } from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      // Tokens, not `bg-obsidian` + `text-white`: on the light themes this
      // screen rendered white-on-white, 1:1 — unreadable at exactly the moment
      // something has already gone wrong. Caught by the audit, 29 Aug 2026.
      return (
        <div className="min-h-screen bg-surface-0 flex items-center justify-center p-8">
          <div className="max-w-md text-center">
            <div className="w-16 h-16 rounded-ui-lg bg-status-bad-soft border border-status-bad/20 flex items-center justify-center mx-auto mb-6">
              <AlertTriangle className="w-8 h-8 text-status-bad" />
            </div>
            <h1 className="text-section text-ink-1 mb-2">Something went wrong</h1>
            <p className="text-body text-ink-3 mb-6">
              {this.state.error?.message || 'This screen failed to load. Reloading usually clears it.'}
            </p>
            <button
              onClick={() => { this.setState({ hasError: false, error: null }); window.location.reload(); }}
              className="inline-flex items-center gap-2 px-4 py-2 rounded-ui bg-brand text-brand-ink text-body font-medium hover:bg-brand-hover transition-colors"
              data-testid="error-boundary-reload"
            >
              <RefreshCw className="w-4 h-4" /> Reload page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
